import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class EntityService {

  protected abstract url: string;

  protected constructor(protected http: HttpClient) {
  }

  getList(lazyLoadEvent: string, params?: any): Observable<any> {
    return this.http.get(`${this.url}/list?lazyLoadEvent=${lazyLoadEvent}`, {params});
  }

  get(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}/detail`);
  }

  create(item: any): Observable<any> {
    return this.http.post(`${this.url}/create`, item);
  }

  update(id: string, item: any): Observable<any> {
    return this.http.put(`${this.url}/${id}/update`, item);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.url}/${id}/delete`);
  }

}
